import type { FunctionComponent } from 'react';

import type { EntityStatusColor } from './entity-status.utils';
import { ctw } from '@/common';
import { getEntityStatusColor } from './entity-status.utils';

type EntityStatusIndicatorProps = {
  status: string | null | undefined;
  className?: string;
  emptyLabel: string;
};

const colorToClasses: Record<EntityStatusColor, string> = {
  green: 'bg-green-500',
  gray: 'bg-gray-400',
  red: 'bg-red-500',
};

export const EntityStatusIndicator: FunctionComponent<EntityStatusIndicatorProps> = ({
  status,
  className,
  emptyLabel,
}) => {
  if (!status) {
    return <span className="text-slate-400">{emptyLabel}</span>;
  }

  const color = getEntityStatusColor(status);

  return (
    <span className={ctw('inline-flex items-center gap-2', className)}>
      {color && (
        <span
          className={ctw('h-2.5 w-2.5 shrink-0 rounded-full', colorToClasses[color])}
          aria-hidden="true"
        />
      )}
      <span>{status}</span>
    </span>
  );
};
